import React from 'react';
import styled from 'styled-components';
import BannerImage from './BannerImage';

const StyledLink = styled.a`
  width: 100%;
  height: 100%;
`;

export interface BannerPDFProps {
  pdfUrl: string;
  thumbnailUrl?: string;
}

const BannerPDF: React.FC<BannerPDFProps> = ({
  pdfUrl,
  thumbnailUrl,
}: BannerPDFProps) => (
  pdfUrl
    ? (
      <StyledLink href={pdfUrl} target="_blank" rel="noopener noreferrer">
        {thumbnailUrl && (
        <BannerImage
          imageUrl={thumbnailUrl}
          name="pdf Banner"
        />
        )}
      </StyledLink>
    )
    : (
      thumbnailUrl && (
        <BannerImage
          imageUrl={thumbnailUrl}
          name="pdf Banner"
        />
      )
    )
);

export default BannerPDF;
